export const SHORT_DAY_MAPPING = {
	'Su': 'Sunday',
	'Mo': 'Monday',
	'Tu': 'Tuesday',
	'We': 'Wednesday',
	'Th': 'Thursday',
	'Fr': 'Friday',
	'Sa': 'Saturday',
};

export const DAY_VAL_MAPPING = {
	'Monday': 0,
	'Tuesday': 1,
	'Wednesday': 2,
	'Thursday': 3,
	'Friday': 4,
	'Saturday': 5,
	'Sunday': 6,
};
